<script>
import MessageUnknown from './MessageUnknown.vue';
import MessageMemberJoined from './MessageMemberJoined.vue';
import MessageMemberLeft from './MessageMemberLeft.vue';
import MessageText from './MessageText.vue';
import MessageAskLife from './MessageAskLife.vue';

export default {
  name: 'Message',

  props: {
    messageCont: {
      type: Object,
      required: true,
    }
  },

  render(createElement) {
    const componentType = getComponentType(this.messageCont.messageType);
    const data = {
      props: {
        messageType: this.messageCont.messageType,
        message: this.messageCont.message,
      },
    };
    return createElement(componentType, data);
  },
};

const MESSAGE_TYPE_MEMBER_JOINED = 1 // Player has joined the club.
const MESSAGE_TYPE_MEMBER_LEFT   = 2 // Player has left the club.
const MESSAGE_TYPE_TEXT          = 3 // Player posted text message.
const MESSAGE_TYPE_ASK_LIFE      = 4 // Player asks for life.

function getComponentType(messageType) {
  switch(messageType) {
    case MESSAGE_TYPE_MEMBER_JOINED: return MessageMemberJoined;
    case MESSAGE_TYPE_MEMBER_LEFT:   return MessageMemberLeft;
    case MESSAGE_TYPE_TEXT:          return MessageText;
    case MESSAGE_TYPE_ASK_LIFE:      return MessageAskLife;
  }
  return MessageUnknown;
}

</script>
